import React from 'react'

import s from './styles.module.scss'

import ControlledSelectField from '../../../../../../../../../../forms/select-field/ControlledSelectField'
import { getVatRateOptions } from '../../../../../../../../shared/utils/house-options.utils'
import { HouseStudyDayIndividualFieldProps } from '../../../form-container/HouseStudyDayIndividualFormContainer'

export const HouseStudyDayIndividualVatField = ({
  control,
  isFieldDisabled,
  currencyArea,
}: HouseStudyDayIndividualFieldProps) => {
  return (
    <div className={s.vatRate}>
      <ControlledSelectField
        control={control}
        rules={{ required: 'Champ requis.' }}
        name='options.vatRate'
        labelClassName={s.vatRateLabel}
        inline={true}
        menuPlacement='top'
        label='TVA applicable aux accès aux espaces de travail'
        options={getVatRateOptions(currencyArea.vatRates)}
        disabled={isFieldDisabled}
        placeholder='0,00 %'
      />
    </div>
  )
}
